module.exports = __webpack_public_path__ + "assets/edit.c16a8c2beecfc666eafc8fb2261bcd72.png";